import { useCallback, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../constants';
import { readLastKit } from '../lib/kitLogic';
import { getUrlParameter, stripUrlParams } from '../lib/url';
import { logError } from '../lib/log';

export const useSharedKit = ({ t, onNavigateHome }) => {
  const [shareKit, setShareKit] = useState(null);
  const [mixerKit, setMixerKit] = useState(null);

  const openShareModal = useCallback(() => setShareKit(readLastKit()), []);
  const closeShareModal = useCallback(() => setShareKit(null), []);

  const checkShareParam = useCallback(() => {
    if (getUrlParameter('share_kit') !== '1') return;
    openShareModal();
    stripUrlParams('share_kit');
  }, [openShareModal]);

  const loadSharedKit = useCallback(async (productsList) => {
    const kitId = getUrlParameter('kit');
    if (!kitId) return;
    try {
      const { data: kit } = await axios.get(`${API}/beautykit/${kitId}`);
      const resolved = (kit.products || []).map((id) => (productsList || []).find((p) => p.id === id)).filter(Boolean);
      if (resolved.length) {
        setMixerKit({ products: resolved, name: kit.name, ts: Date.now() });
        onNavigateHome?.();
      }
    } catch (error) {
      logError('Error loading shared kit:', error);
      toast.error(t('beautykit.link_error'));
    }
    stripUrlParams('kit');
  }, [onNavigateHome, t]);

  return { shareKit, mixerKit, openShareModal, closeShareModal, checkShareParam, loadSharedKit };
};

export default useSharedKit;
